import * as React from "react";
const SvgDevicePackets = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m9.596 2.092-2.14 2.142-2.142 2.141 2.141 2.14 2.14 2.141.53-.531.531-.53L9.42 8.36 8.184 7.123H20.622v5.818h1.505V5.625H8.184L9.42 4.389l1.236-1.235-.531-.531ZM1.87 11.059v7.316h13.945l-1.236 1.236-1.236 1.235.531.531.53.53 2.138-2.137a597.31 597.31 0 0 0 2.139-2.145c0-.003-.963-.966-2.139-2.143l-2.139-2.138-.529.531-.531.53 1.236 1.236 1.236 1.236H3.378v-5.818h-.753Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDevicePackets;
